let forms = {
   add_payment_option: {
      icon: 'fa fa-money-check-alt',
      title: 'Add Payment Options',
      subtitle: 'Provide payment option details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'name',
            validation: 'required|min:3|max:150', label: 'Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'currency',
            validation: 'required|min:3|max:3', label: 'Currency',
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'amount_per_card',
            validation: 'required|min:1|max:100|numeric', label: 'Price Per Card',
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'deposit_per_card',
            validation: 'required|min:1|max:100|numeric', label: 'Minimum Deposit Per Card',
         }
      ]
   },
   edit_payment_option: {
      icon: 'fa fa-money-check-alt',
      title: 'Edit Payment Options',
      subtitle: 'Provide payment option details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'name',
            validation: 'required|min:3|max:150', label: 'Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'currency',
            validation: 'required|min:3|max:3', label: 'Currency',
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'amount_per_card',
            validation: 'required|min:1|max:100|numeric', label: 'Price Per Card',
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'deposit_per_card',
            validation: 'required|min:1|max:100|numeric', label: 'Minimum Deposit Per Card',
         }
      ]
   },
   upload_fuel_station: {
      icon: 'fa fa-upload',
      title: 'Upload Fuel Station',
      subtitle: 'Provide file containing fuel stations',
      forms: [
         {
            type: 'upload', class: 'col-12 big-upload', model: 'stations', validation: 'required', label: 'Fuel Stations',
            accept: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel', multiple: false
         },
      ]
   },
}

let tables = {
   payment_options: {
      icon: 'fa fa-money-check-alt',
      title: 'Payment Options',
      table_fields: [
         { name: 'Name', align: 'l' },
         { name: 'Currency', align: 'l' },
         { name: 'Amount Per Card', align: 'l' },
         { name: 'Min Deposit Per Card', align: 'l' },
         { name: 'Created At', align: 'c' },
         { name: 'Actions', align: 'c' }
      ],
      search_fields: ["name","currency"],
      row_data: [
         { type: 'text', field: 'name', class: 'bold' },
         { type: 'text', field: 'currency', class: 'bold' },
         { type: 'text', field: 'amount_per_card', class: 'bold' },
         { type: 'text', field: 'deposit_per_card', class: 'bold' },
         { type: 'date', field: 'created_at', class: 'center bolder small', format: 'DD-MM-YYYY HH:mm' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               { type: 'menu', title: 'View', event: 'payment_option:view' },
               { type: 'menu', title: 'Edit', event: 'payment_option:edit', icon: 'fa-edit' },
               { type: 'menu', title: 'Delete', event: 'payment_option:delete', icon: 'fa-trash-alt' },
            ]
         },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}